var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4CAF50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 3,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 3,
    height: 12
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20H22",
    stroke: "#2196F3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C6 14 8 8 12 12C16 16 18 6 22 10",
    stroke: "#FFC107",
    strokeWidth: 2,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/dashboard1.d6cf74ad4cf97bc714e07fb62a341fd5.svg";
export { ForwardRef as ReactComponent };